import { motion, useAnimationFrame } from "framer-motion";
import { useTheme } from "next-themes";
import { useRef, useState } from "react";

const WAVE_COUNT = 3;
const COLORS_DARK = [
  "#2485EC", // Tailwind primary blue
  "#FEC941", // Tailwind secondary yellow
  "#ff00c8"  // Accent pink
];
const COLORS_LIGHT = [
  "#2485EC", // Tailwind primary blue
  "#FEC941", // Tailwind secondary yellow
  "#ff00c8"  // Accent pink
];

function generateWavePath({ amplitude, frequency, phase, height, width }: { amplitude: number, frequency: number, phase: number, height: number, width: number }) {
  let d = "M 0 " + height / 2;
  for (let x = 0; x <= width; x += 2) {
    const y = height / 2 + amplitude * Math.sin((x / width) * frequency * Math.PI * 2 + phase);
    d += ` L ${x} ${y}`;
  }
  return d;
}

function AnimatedWave({ color, amplitude, frequency, speed, blur, width, height }: any) {
  const [phase, setPhase] = useState(0);
  const pathRef = useRef(null);
  useAnimationFrame((t) => {
    setPhase((prev) => prev + speed);
  });
  const d = generateWavePath({ amplitude, frequency, phase, height, width });
  return (
    <motion.path
      d={d}
      fill="none"
      stroke={color}
      strokeWidth={6}
      opacity={0.7}
      filter={blur ? "url(#blur-glow)" : undefined}
      ref={pathRef}
    />
  );
}

export default function EqualizerBackground() {
  // const theme = useTheme();
  const { resolvedTheme } = useTheme();
  console.log(resolvedTheme);
  const isDark = resolvedTheme === "dark";
  const colors = isDark ? COLORS_DARK : COLORS_LIGHT;
  const width = 1920;
  const height = 300;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 0,
        pointerEvents: "none",
        overflow: "hidden",
        background: isDark ? "#000" : "#fff",
        transition: "background 0.3s",
      }}
      aria-hidden="true"
    >
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      >
        <defs>
          <filter id="blur-glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="8" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <AnimatedWave color={colors[0]} amplitude={40} frequency={2.2} speed={0.025} blur width={width} height={height} />
        <AnimatedWave color={colors[1]} amplitude={28} frequency={1.5} speed={0.018} blur width={width} height={height} />
        <AnimatedWave color={colors[2]} amplitude={18} frequency={1.1} speed={0.012} blur width={width} height={height} />
      </svg>
    </div>
  );
} 